import { cn } from "@pulsex/utils";

type TimeProps = {
  item?: string;
  className?: string;
};

export const Time = ({ item, className }: TimeProps) => {
  if (!item) return;

  return (
    <p className={cn("text-[#3d3d3c] text-sm", className)}>
      {item}
    </p>
  );
};
